import React, { useEffect, useState } from "react";
import moment from "moment";
import { CampoEstatico, Row, Col, Box, PosicaoTituloCampoEstatico, Alerta, TipoAlerta } from "@intechprev/componentes-web";

import { FuncionarioService, DependenteService, LogService } from "../../services";
import { MasterPage } from "..";
import { DependenteEntidade, FuncionarioDados } from "../../entidades";
import { NumFuncionalidade } from "../MasterPage";
import { reCAPTCHA } from "../../helpers";
import { LoadingComponent } from "../../components";

export const DadosPessoais: React.FC = ({ ...rest }) => {
  // const recaptcha = new reCAPTCHA("dados_pessoais");

  const [Dados, setDados] = useState<FuncionarioDados>(new FuncionarioDados());
  const [Dependentes, setDependentes] = useState<Array<DependenteEntidade>>([]);
  const [Idade, setIdade] = useState<string>("");

  const [Loading, setLoading] = useState<boolean>(true);
  const [Erro, setErro] = useState<string>("");

  useEffect(() => {
    (async () => {
      new reCAPTCHA("dados_pessoais");
      setLoading(true);
      try {
        await LogService.CriarLog(NumFuncionalidade.SEUS_DADOS);
        const dependentes = await DependenteService.Buscar();
        setDependentes(dependentes);

        const dados = await FuncionarioService.Buscar();
        setDados(dados);

        const dtNascimento = moment(dados.DadosPessoais.DT_NASCIMENTO, "DD/MM/YYYY");
        const idade = moment().diff(dtNascimento, "years");
        setIdade(`${idade} anos`);
      }
      catch (e) {
        const err: any = e;
        const Error = err.response ? err.response.data : err;
        setErro(Error);
      }
      finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <MasterPage Funcionalidade={NumFuncionalidade.SEUS_DADOS} {...rest}>
      {Loading && <LoadingComponent />}

      {!Loading && Erro && <Alerta tipo={TipoAlerta.danger} mensagem={Erro} />}

      {!Loading && !Erro && <>
        <Row>
          <Col tamanho={"12"} className={"col-lg-6"}>
            <Box titulo={"Dados Pessoais"}>
              {Dados.DadosPessoais && (
                <>
                  <div className="form-row">
                    <CampoEstatico
                      titulo={"Nome"}
                      valor={Dados.DadosPessoais.NOME_ENTID}
                      id={"0"}
                      posicaoTitulo={PosicaoTituloCampoEstatico.cima}
                    />
                  </div>

                  <div className="form-row">
                    <CampoEstatico
                      titulo={"Empresa"}
                      valor={Dados.Empresa.NOME_ENTID}
                      id={"1"}
                      posicaoTitulo={PosicaoTituloCampoEstatico.cima}
                    />

                    <CampoEstatico
                      titulo={"Matrícula"}
                      valor={Dados.Funcionario.NUM_MATRICULA}
                      id={"2"}
                      posicaoTitulo={PosicaoTituloCampoEstatico.cima}
                    />
                  </div>

                  <div className="form-row">
                    <CampoEstatico
                      titulo={"Sexo"}
                      valor={Dados.DadosPessoais.DS_SEXO}
                      id={"3"}
                      posicaoTitulo={PosicaoTituloCampoEstatico.cima}
                    />

                    <CampoEstatico
                      titulo={"Estado Civil"}
                      valor={Dados.DS_ESTADO_CIVIL}
                      id={"4"}
                      posicaoTitulo={PosicaoTituloCampoEstatico.cima}
                    />
                  </div>

                  <div className="form-row">
                    <CampoEstatico titulo={"RG"} valor={Dados.DadosPessoais.NU_IDENT} id={"5"} posicaoTitulo={PosicaoTituloCampoEstatico.cima} />

                    <CampoEstatico
                      titulo={"Órgão Emissor RG"}
                      valor={Dados.DadosPessoais.ORG_EMIS_IDENT}
                      id={"6"}
                      posicaoTitulo={PosicaoTituloCampoEstatico.cima}
                    />
                  </div>

                  <div className="form-row">
                    <CampoEstatico
                      titulo={"Emissão RG"}
                      valor={Dados.DadosPessoais.DT_EMIS_IDENT}
                      id={"7"}
                      posicaoTitulo={PosicaoTituloCampoEstatico.cima}
                    />

                    <CampoEstatico
                      titulo={"CPF"}
                      valor={Dados.DadosPessoais.CPF_CGC}
                      tamanhoCampo={"6"}
                      id={"8"}
                      posicaoTitulo={PosicaoTituloCampoEstatico.cima}
                    />
                  </div>

                  <div className="form-row">
                    <CampoEstatico
                      titulo={"Data de nascimento"}
                      valor={Dados.DadosPessoais.DT_NASCIMENTO}
                      id={"9"}
                      posicaoTitulo={PosicaoTituloCampoEstatico.cima}
                    />

                    <CampoEstatico titulo={"Idade"} valor={Idade} id={"10"} posicaoTitulo={PosicaoTituloCampoEstatico.cima} />
                  </div>

                  <div className="form-row">
                    <CampoEstatico
                      titulo={"Data de Admissão"}
                      valor={Dados.Funcionario.DT_ADMISSAO}
                      id={"11"}
                      posicaoTitulo={PosicaoTituloCampoEstatico.cima}
                    />

                    <CampoEstatico
                      titulo={"Data de Recadastramento"}
                      valor={Dados.Funcionario.DT_RECADASTRO}
                      id={"12"}
                      posicaoTitulo={PosicaoTituloCampoEstatico.cima}
                    />
                  </div>

                  <div className="form-row">
                    <CampoEstatico
                      titulo={"Nome do Pai"}
                      valor={Dados.DadosPessoais.NOME_PAI}
                      id={"13"}
                      posicaoTitulo={PosicaoTituloCampoEstatico.cima}
                    />

                    <CampoEstatico
                      titulo={"Nome da Mãe"}
                      valor={Dados.DadosPessoais.NOME_MAE}
                      id={"14"}
                      posicaoTitulo={PosicaoTituloCampoEstatico.cima}
                    />
                  </div>

                  <div className={"form-row"}>
                    <CampoEstatico
                      titulo={"Telefone Residencial"}
                      valor={Dados.Entidade.FONE_ENTID}
                      posicaoTitulo={PosicaoTituloCampoEstatico.cima}
                    />

                    <CampoEstatico
                      titulo={"Telefone Celular"}
                      valor={Dados.DadosPessoais.FONE_CELULAR}
                      posicaoTitulo={PosicaoTituloCampoEstatico.cima}
                    />
                  </div>

                  <div className="form-row">
                    <CampoEstatico
                      titulo={"E-mail"}
                      valor={Dados.DadosPessoais.EMAIL_AUX}
                      tamanhoCampo={"6"}
                      id={"16"}
                      posicaoTitulo={PosicaoTituloCampoEstatico.cima}
                    />
                  </div>
                </>
              )}
            </Box>
          </Col>

          <Col tamanho={"12"} className={"col-lg-6"}>
            <Box titulo={"Endereço"}>
              {Dados.Entidade && (
                <div>
                  <div className={"form-row"}>
                    <CampoEstatico
                      titulo={"Endereço"}
                      valor={Dados.Entidade.END_ENTID}
                      id={"17"}
                      posicaoTitulo={PosicaoTituloCampoEstatico.cima}
                    />

                    <CampoEstatico
                      titulo={"Número"}
                      valor={Dados.Entidade.NR_END_ENTID}
                      id={"18"}
                      posicaoTitulo={PosicaoTituloCampoEstatico.cima}
                    />
                  </div>
                  <div className={"form-row"}>
                    <CampoEstatico
                      titulo={"Complemento"}
                      valor={Dados.Entidade.COMP_END_ENTID}
                      id={"19"}
                      posicaoTitulo={PosicaoTituloCampoEstatico.cima}
                    />
                    <CampoEstatico
                      titulo={"Bairro"}
                      valor={Dados.Entidade.BAIRRO_ENTID}
                      id={"20"}
                      posicaoTitulo={PosicaoTituloCampoEstatico.cima}
                    />
                  </div>
                  <div className="form-row">
                    <CampoEstatico
                      titulo={"Cidade"}
                      valor={Dados.Entidade.CID_ENTID}
                      tamanhoCampo={"4"}
                      id={"21"}
                      posicaoTitulo={PosicaoTituloCampoEstatico.cima}
                    />

                    <CampoEstatico
                      titulo={"UF"}
                      valor={Dados.Entidade.UF_ENTID}
                      tamanhoCampo={"2"}
                      id={"22"}
                      posicaoTitulo={PosicaoTituloCampoEstatico.cima}
                    />

                    <CampoEstatico titulo={"CEP"} valor={Dados.Entidade.CEP_ENTID} id={"23"} />
                  </div>
                </div>
              )}
            </Box>

            <Box titulo={"Dados Bancários"}>
              {Dados.DadosPessoais && (
                <div>
                  <div className="form-row">
                    <CampoEstatico
                      titulo={"Banco"}
                      valor={Dados.Entidade.NUM_BANCO}
                      tamanhoCampo={"4"}
                      id={"24"}
                      posicaoTitulo={PosicaoTituloCampoEstatico.cima}
                    />

                    <CampoEstatico
                      titulo={"Agência"}
                      valor={Dados.Entidade.NUM_AGENCIA}
                      tamanhoCampo={"4"}
                      id={"25"}
                      posicaoTitulo={PosicaoTituloCampoEstatico.cima}
                    />

                    <CampoEstatico
                      titulo={"Conta"}
                      valor={Dados.Entidade.NUM_CONTA}
                      tamanhoCampo={"4"}
                      id={"26"}
                      posicaoTitulo={PosicaoTituloCampoEstatico.cima}
                    />
                  </div>
                  <div className="form-row"></div>
                </div>
              )}
            </Box>

            <Box titulo={"Beneficiários"}>
              {Dependentes.length > 0 && <>
                <table className={"table table-responsive"}>
                  <thead>
                    <tr>
                      <th style={{ width: "250" }}>Nome</th>
                      <th>Sexo</th>
                      <th style={{ width: "150" }}>Data de Nascimento</th>
                      <th style={{ width: "150" }}>Grau de Parentesco</th>
                      <th>CPF</th>
                      <th>Pensão</th>
                      <th>Pecúlio</th>
                      <th>% Pecúlio</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Dependentes.map((dependente: any, index: number) => {
                      return (
                        <tr key={index}>
                          <td>{dependente.NOME_DEP}</td>
                          <td>{dependente.SEXO_DEP === "F" ? "FEMININO" : "MASCULINO"}</td>
                          <td>{dependente.DT_NASC_DEP}</td>
                          <td>{dependente.DS_GRAU_PARENTESCO}</td>
                          <td>{typeof dependente.CPF !== "undefined" || dependente.CPF === "" ? dependente.CPF : "-"}</td>
                          <td>{dependente.PLANO_PREVIDENCIAL === "S" ? "SIM" : "NÃO"}</td>
                          <td>{dependente.PECULIO === "S" ? "SIM" : "NÃO"}</td>
                          <td>
                            <CampoEstatico valor={dependente.PERC_PECULIO} />
                          </td>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
              </>}

              {Dependentes.length === 0 && <Alerta tipo={TipoAlerta.info} mensagem={"Nenhum Beneficiário disponível para esse plano."} />}
            </Box>
          </Col>
        </Row>
      </>}
    </MasterPage>
  );
}
